import * as echarts from 'echarts';
import {stockTypeMap} from '@/assets/utils/commonData'
export const budgetMixin = {
  data(){
    return{
      dataObj:{},
      stockTypeMap,
    }
  },
  methods: {
    pieChart(obj){
      var obj = this.dataObj.statePriceMap
      var myChart=echarts.init(document.getElementById('pieChart'))
      var arr=[]
      var colorArr=['#C3B6E6','#CEDD79','#FACFA9','#71D4D4','#A3D2F6','#409EFF','#67C23A','#E6A23C','#F56C6C']
      var arr2=[];
      if(obj&&!(typeof(obj)=="undefined")){
          arr2=Object.keys(obj)
      }
      arr2.forEach((item,index)=>{
        arr.push({
          value:obj[item],
          name:this.stockTypeMap[item].typeName,
          itemStyle:{color:colorArr[index]}}
        )
      })
      var option = {
        legend: {
          top: 'bottom'
        },
        tooltip: {
          formatter: function(data) {
            return data.name+Math.round(data.percent)+"%"+"  "+data.value+"￥"
          }
        },
        backgroundColor: '#ffffff',
        title: {
          text: '整体费用分布总览饼图',
          x: 'center',
          textStyle: {
            fontWeight: 'bold',              //标题颜色
            color: '#1E90FF',
          },
        },
        series : [
          {
            name: '访问来源',
            type: 'pie',
            radius: '50%',
            data:arr,
            roseType: 'angle',
            label: {
              normal: {
                show: true,//是否显示标签
                position: 'left',
                //显示的标签的内容
                //a（系列名称），b（数据项名称），c（数值）, d（百分比）
                formatter: "{b}{d}%",
                formatter:function(data){
                  return data.name+Math.round(data.percent)+"%"+"  "+data.value+"￥";
                }
              }
            },
            itemStyle: {
              normal: {
                shadowBlur: 200,
                shadowColor: 'rgba(255, 255, 255, 1)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option);
    },
    getCountryNumber(str,obj){
      var countryIndex = str.indexOf('国');
      var cityNumber
      if(countryIndex==-1){
        cityNumber = str.slice(0,str.indexOf('地'))
      }else{
        var cityArr = str.split("国")
        var cityStr = cityArr[cityArr.length-1];
        cityNumber = cityStr.slice(0,cityStr.indexOf('地'))
      }
      this.$set(obj,'countryNumber',countryIndex==-1?1:str.slice(0,countryIndex))
      this.$set(obj,'cityNumber',cityNumber)
    }
  }
}